<template>
  <b-modal width="680px"
    :active.sync="isShowModalSync"
    :on-cancel="cancel"
    v-if="isShowModalSync">
    <div class="card" style="border-radius: 8px;">
      <slot></slot>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CustomHeaderModal',
  componentName: 'CustomHeaderModal',
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    isShowModal () {
      this.isShowModalSync = this.isShowModal
    }
  },
  data () {
    return {
      isShowModalSync: this.isShowModal
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Modals/CustomHeaderModal.vue